export enum DriverState {
  DEFAULT,
  EDIT,
  ADD,
  ASSIGN,
  AVATAR,
  LIST,
  HISTORY
}
